import {Action} from "@ngrx/store";

export const LOAD_CERTIFICATES: string = '[info] Load Certificates';
export const LOAD_CERTIFICATES_SUCCESS: string = '[info] Load Certificates Success';
export const LOAD_CERTIFICATES_FAIL: string = '[info] Load Certificates Fail';

export class LoadCertificates implements Action {
  readonly type: string = LOAD_CERTIFICATES;
  constructor(public payload: number) {}
}

export class LoadCertificatesSuccess implements Action {

  readonly type: string = LOAD_CERTIFICATES_SUCCESS;
  constructor(public payload: {
    websiteId: number,
    entities: {[websiteId: number]: any},
  }) {}

}

export class LoadCertificatesFail implements Action {

  readonly type: string = LOAD_CERTIFICATES_FAIL;
  constructor(public payload: string) {}

}


export type CertificatesAction = LoadCertificates | LoadCertificatesSuccess | LoadCertificatesFail;
